import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFacultyPayload, IInitialStateFaculty } from "../types";
import { GetFaculty } from "./thunk";
import { GetDeleteDegree } from "../../EducationalDegree/store/thunk";

const initialState: IInitialStateFaculty = {
    facultyData: [],
    selectedFacultyIDs: [],
    isLoadingFaculty: true,
    filteredFaculty: [],
    facultyRestore: [],
    isViewRestoreFaculty: false,
};

const facultySlice = createSlice({
    name: "faculty",
    initialState,
    reducers: {
        setFaculty: (state, action: PayloadAction<{ data: IFacultyPayload[]; defaultLanguage: string }>) => {
            const { data, defaultLanguage } = action.payload;
            if (!Array.isArray(data)) {
                return;
            }
            state.facultyData = data;
            state.filteredFaculty = state.facultyData.flatMap(item => {
                return item.translations
                    .filter(elem => elem.slug === defaultLanguage)
                    .map(elem => ({
                        id: item.id,
                        abbreviation: elem.abbreviation || "",
                        faculty: elem.faculty || "",
                    }));
            });
        },

        setFacultyRestoreData: (state, action) => {
            state.facultyRestore = action.payload;
        },

        deletedFaculty: (state, action: PayloadAction<number>) => {
            state.facultyData = state.facultyData.filter(elem => elem.id !== action.payload);
        },

        setIsViewRestoreFaculty: state => {
            state.isViewRestoreFaculty = !state.isViewRestoreFaculty;
        },
        deletedRestoreFaculty: (state, action) => {
            state.facultyRestore = state.facultyRestore.filter(elem => elem.id !== action.payload);
        },
        setSelectedFacultyIDs: (state, action) => {
            state.selectedFacultyIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetFaculty.pending, state => {
                state.isLoadingFaculty = true;
            })
            .addCase(GetFaculty.fulfilled, state => {
                state.isLoadingFaculty = false;
            })
            .addCase(GetFaculty.rejected, state => {
                state.isLoadingFaculty = false;
            })
            .addCase(GetDeleteDegree.pending, state => {
                state.isLoadingFaculty = true;
            })
            .addCase(GetDeleteDegree.fulfilled, state => {
                state.isLoadingFaculty = false;
            })
            .addCase(GetDeleteDegree.rejected, state => {
                state.isLoadingFaculty = false;
            });
    },
});

export const {
    setFaculty,
    deletedFaculty,
    setIsViewRestoreFaculty,
    deletedRestoreFaculty,
    setFacultyRestoreData,
    setSelectedFacultyIDs,
} = facultySlice.actions;
export default facultySlice;
